import AddDeliveryOrder from '../AddDeliveryOrder'
export default function DeliveryOrderDetail() {
  return <AddDeliveryOrder></AddDeliveryOrder>
}
import AddDeliveryOrder from '../AddDeliveryOrder'
export default function DeliveryOrderDetail() {
  return <AddDeliveryOrder></AddDeliveryOrder>
}
